/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from "react";
import moment from "moment-timezone";
import Loader from "../../../../Common/Component/Loader";
import {message} from "antd";

class AddNote extends Component {
  state = {
    noteList: [],
    note: '',
    loader: false,
    errors: {}
  }

	componentDidMount = () => {
	  const { customerId, getAccountNotes } = this.props;
	  if (customerId) {
	    this.setState({ loader: true });
	    getAccountNotes({ user__uuid: customerId }) // get account notes
	  }
	}

	UNSAFE_componentWillReceiveProps = (nextProps) => {
  	// message.destroy()
	  this.setState({loader: false})
	  if (nextProps?.accountNotes) {
	    // get note list
	    if (Object.keys(nextProps?.accountNotes?.noteList).length > 0
				&& JSON.stringify(nextProps?.accountNotes?.noteList?.results) !== JSON.stringify(this.state.noteList)) {
	      this.setState({ noteList: nextProps?.accountNotes?.noteList?.results || [], loader: false });
	    }
	  }
	}

	// on text change
	onTextChange = (e) => {
	  this.setState({ [e.target.name]: e.target.value });
	};

	// on save note
	onSaveNote = () => {
	  const { note } = this.state;
	  const {customerId, getAccountNotes} = this.props;
	  if (note) {
	    this.setState({ loader: true });
	    const params = {
	      notes: note,
	      user: this.props.customerId,
	      created_by_details: {
	        uuid: JSON.parse(localStorage.getItem('authUser'))?.user?.uuid
	      }
	    };
	    this.props.addAccountNotes(params);
	    setTimeout(() => getAccountNotes({ user__uuid: customerId }), 1000)
	    this.setState({ loader: false, note: '', errors: {} });
	  } else {
	  	this.setState({errors: {note: 'Note is required'}})
	  }
	};

	cancel = () => {
	  this.setState({
	    note: ''
	  });
	  this.props.collapse();
	}
	
	render() {
	  const { noteList, note, loader, errors } = this.state;
	  return (
	    <div className="drawer-wrapper">
	      {loader && <Loader />}
	      <div className="page-side rdrawer">
	        <div className="fitem plain-control">
	          <textarea
	            rows="4"
	            name="note"
	            type="text"
	            placeholder={"Start typing to add your notes ..."}
	            value={note}
	            onChange={(e) => this.onTextChange(e)} />
	          {errors?.['note'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['note']}</label> : ''}
	          {/* <button
	            className={`btn btn-primary float-right mt-10`}
	            onClick={() => this.onSaveNote()}>
							Save Note</button> */}
	        </div>
	        <div className="card-body pb-0">
			  {
	            noteList.filter(item => !item.is_private_note).map((item, index) =>
	              <div className="notes" key={`notes${index}`}>
	                <span>{item?.notes}</span>
	                <small>{`${moment(item?.created_at).format('MMM DD, YYYY')} . ${item?.created_by_details?.role || '-'} . ${item?.created_by_details?.first_name} ${item?.created_by_details?.last_name}`}</small>
	              </div>
	            )
	          }
	        </div>
					
	      </div>
	      <div className="footer">
	        <button className="btn btn-brand btn-bdr" onClick={ () => { this.cancel() }}>Cancel</button>
	        <button className="btn btn-warning" onClick={() => this.onSaveNote()}>Add Note</button>
	      </div>
	    </div>
	  )
	}
}

export default AddNote;
